import React from "react";
import {url} from "../utils/UrlsUtil";
import "../../style/modal/_template_type_choice_modal.scss";
import {
    TEMPLATE_KBN_BOOK_WRAP, TEMPLATE_KBN_BOX_WRAP,
    TEMPLATE_KBN_EGIFT_MESSAGE,
    TEMPLATE_KBN_GIFT_MESSAGE, TEMPLATE_KBN_TRUX_BOX_WRAP, TEMPLATE_TYPE_MESSAGE, TEMPLATE_TYPE_WRAPPING
} from "../const/TemplateConst";
import {Modal, ModalHeader, ModalTitle, ModalBody, Card, CardImg, CardBody, Button} from "react-bootstrap";

interface TemplateTypeChoiceModalProps{
    type: string;
    show: boolean;
    handleClosed: () => void;
    handleSelected: ( template_kbn: string ) => void;
}

const TemplateTypeChoiceModal:React.FC<TemplateTypeChoiceModalProps> = ({
    type = '',
    show = false,
    handleClosed = () => {},
    handleSelected = () => {}
}) => {
    const onClickButton = (template_kbn: string) => {
        handleSelected(template_kbn);
    }
    return (
        <Modal className="template-type-choice-modal" show={show} onHide={handleClosed} centered>
            <ModalHeader closeButton>
                <ModalTitle><img src={url("/images/logo/geeva_logo.png")}/></ModalTitle>
            </ModalHeader>
            <ModalBody>
                {type === TEMPLATE_TYPE_MESSAGE && <div className="choice-list">
                    <Card className="text-center">
                        <CardImg variant="top" src={url("/images/common/online_msg_type.png")}></CardImg>
                        <CardBody>
                            <Button variant="success" onClick={()=>{onClickButton(TEMPLATE_KBN_GIFT_MESSAGE)}}>通常オンラインメッセージ</Button>
                        </CardBody>
                    </Card>
                    <Card className="text-center">
                        <CardImg variant="top" src={url("/images/common/egift_msg_type.png")}></CardImg>
                        <CardBody>
                            <Button variant="success" onClick={()=>{onClickButton(TEMPLATE_KBN_EGIFT_MESSAGE)}}>EGiftメッセージ</Button>
                        </CardBody>
                    </Card>
                </div>}
                {type === TEMPLATE_TYPE_WRAPPING && <div className="choice-list">
                    <Card className="text-center">
                        <CardImg variant="top" src={url("/images/common/box_type.png")}></CardImg>
                        <CardBody>
                            <Button variant="success" onClick={()=>{onClickButton(TEMPLATE_KBN_BOX_WRAP)}}>BOX用のし・包装</Button>
                        </CardBody>
                    </Card>
                    <Card className="text-center">
                        <CardImg variant="top" src={url("/images/common/trux_box_type.jpg")}></CardImg>
                        <CardBody>
                            <Button variant="success" onClick={()=>{onClickButton(TEMPLATE_KBN_TRUX_BOX_WRAP)}}>TRUX BOX用のし・包装</Button>
                        </CardBody>
                    </Card>
                    <Card className="text-center">
                        <CardImg variant="top" src={url("/images/common/book_type.png")}></CardImg>
                        <CardBody>
                            <Button variant="success" onClick={()=>{onClickButton(TEMPLATE_KBN_BOOK_WRAP)}}>BOOK用のし・包装</Button>
                        </CardBody>
                    </Card>
                </div>}
            </ModalBody>
        </Modal>
    );
}
export default TemplateTypeChoiceModal;